module.exports = __webpack_public_path__ + "img/creative.29de6bb7.svg";